// src/Accordion.js
import React, { useState } from 'react';
import './Accordion.css'; // 이 줄은 Accordion.css 파일을 가져옵니다.

const Accordion = ({ items }) => {
  const [openItemId, setOpenItemId] = useState(null);

  const handleItemClick = (id) => {
    // 현재 열린 항목을 다시 클릭하면 닫고, 다른 항목을 클릭하면 현재 항목을 열도록 토글
    setOpenItemId(openItemId === id ? null : id);
  };

  return (
    <div className="accordion-container">
      {items.map((item) => (
        <div key={item.id} className="accordion-item">
          <div className="accordion-question" onClick={() => handleItemClick(item.id)}>
            {item.question}
            <span className="accordion-icon">{openItemId === item.id ? '▲' : '▼'}</span>
          </div>
          {/* openItemId와 현재 항목의 ID가 같을 때만 답변을 렌더링 */}
          {openItemId === item.id && (
            <div className="accordion-answer">
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;